import React, { lazy } from "react";
import { Route } from "react-router-dom";
import RouteSuspense from "../RouteSuspense";

const ProductItemsStock = lazy(() => import("../../pages/productItemsStock/ProductItemsStock"));
const AssistedRetailPunch = lazy(() => import("../../pages/retailAssisted/AssistedRetailPunch"));
const ArchivedRetailStocks = lazy(() =>
  import("../../pages/productItemsStock/ArchivedRetailStocks")
);

const RetailLiveRoutes = () => (
  <>
    <Route path="/product-items-stock" element={<RouteSuspense><ProductItemsStock /></RouteSuspense>} />
    <Route
      path="/product-items-stock/:productId/archived-stocks"
      element={
        <RouteSuspense>
          <ArchivedRetailStocks />
        </RouteSuspense>
      }
    />
    <Route
      path="/retail/:storeName"
      element={
        <RouteSuspense>
          <AssistedRetailPunch />
        </RouteSuspense>
      }
    />
  </>
);

export default RetailLiveRoutes;
